export enum SSMTypes {
  LT = 1,
  OZ = 2,
  YD = 3,
  FEET = 4,
  SI = 5,
  KT2GL = 6,
  LG = 7,
  RL20 = 8,
  CA = 9,
  PK = 10,
  PR = 11,
  PK50 = 12,
  SP = 13,
  KG = 14,
  M2 = 15,
  RL25 = 16,
  DZ = 17,
  GR = 18,
  CS = 19,
  M3 = 20,
  SY = 21,
  TN = 22,
  PK500 = 23,
  PK10 = 24,
  RL36YD = 25,
  ME = 26,
  RL = 27,
  LB = 28,
  PT = 29,
  GL = 30,
  BL = 31,
  TU = 32,
  DM = 33,
  JR = 34,
  HU = 35,
  PK200 = 36,
  PK4 = 37,
  EA = 38,
  SH = 39,
  KT = 40,
  MT = 41,
  CN = 42,
  DR = 43,
  CM = 44,
  BG = 45,
  GM = 46,
  KT600ML = 47,
  SM = 48,
  FT = 49,
  IN = 50,
  PC = 51,
  QT = 52,
  SF = 53,
  TH = 54,
  ST = 55,
  BX = 56,
  ML = 57,
  PK100 = 58,
}
export const SSMTypeChoices = [
  { Description: "LT", Value: SSMTypes.LT },
  { Description: "OZ", Value: SSMTypes.OZ },
  { Description: "YD", Value: SSMTypes.YD },
  { Description: "FEET", Value: SSMTypes.FEET },
  { Description: "SI", Value: SSMTypes.SI },
  { Description: "KT-2GL", Value: SSMTypes.KT2GL },
  { Description: "LG", Value: SSMTypes.LG },
  { Description: "RL-20", Value: SSMTypes.RL20 },
  { Description: "CA", Value: SSMTypes.CA },
  { Description: "PK", Value: SSMTypes.PK },
  { Description: "PR", Value: SSMTypes.PR },
  { Description: "PK-50", Value: SSMTypes.PK50 },
  { Description: "SP", Value: SSMTypes.SP },
  { Description: "KG", Value: SSMTypes.KG },
  { Description: "M2", Value: SSMTypes.M2 },
  { Description: "RL-25", Value: SSMTypes.RL25 },
  { Description: "DZ", Value: SSMTypes.DZ },
  { Description: "GR", Value: SSMTypes.GR },
  { Description: "CS", Value: SSMTypes.CS },
  { Description: "M3", Value: SSMTypes.M3 },
  { Description: "SY", Value: SSMTypes.SY },
  { Description: "TN", Value: SSMTypes.TN },
  { Description: "PK-500", Value: SSMTypes.PK500 },
  { Description: "PK-10", Value: SSMTypes.PK10 },
  { Description: "RL-36YD", Value: SSMTypes.RL36YD },
  { Description: "ME", Value: SSMTypes.ME },
  { Description: "RL", Value: SSMTypes.RL },
  { Description: "LB", Value: SSMTypes.LB },
  { Description: "PT", Value: SSMTypes.PT },
  { Description: "GL", Value: SSMTypes.GL },
  { Description: "BL", Value: SSMTypes.BL },
  { Description: "TU", Value: SSMTypes.TU },
  { Description: "DM", Value: SSMTypes.DM },
  { Description: "JR", Value: SSMTypes.JR },
  { Description: "HU", Value: SSMTypes.HU },
  { Description: "PK-200", Value: SSMTypes.PK200 },
  { Description: "PK-4", Value: SSMTypes.PK4 },
  { Description: "EA", Value: SSMTypes.EA },
  { Description: "SH", Value: SSMTypes.SH },
  { Description: "KT", Value: SSMTypes.KT },
  { Description: "MT", Value: SSMTypes.MT },
  { Description: "CN", Value: SSMTypes.CN },
  { Description: "DR", Value: SSMTypes.DR },
  { Description: "CM", Value: SSMTypes.CM },
  { Description: "BG", Value: SSMTypes.BG },
  { Description: "GM", Value: SSMTypes.GM },
  { Description: "KT-600ML", Value: SSMTypes.KT600ML },
  { Description: "SM", Value: SSMTypes.SM },
  { Description: "FT", Value: SSMTypes.FT },
  { Description: "IN", Value: SSMTypes.IN },
  { Description: "PC", Value: SSMTypes.PC },
  { Description: "QT", Value: SSMTypes.QT },
  { Description: "SF", Value: SSMTypes.SF },
  { Description: "TH", Value: SSMTypes.TH },
  { Description: "ST", Value: SSMTypes.ST },
  { Description: "BX", Value: SSMTypes.BX },
  { Description: "ML", Value: SSMTypes.ML },
  { Description: "PK-100", Value: SSMTypes.PK100 },
];
